import dayjs from "@lib/dayjs";
import {
  jobMembersProfile,
  unseenMessageCount,
} from "../../endpoints/job.service";
import {
  RESET_UNSEEN_MESSAGE_COUNT,
  SET_CHAT_RECEIVER_DETAILS,
  SET_JOB_MEMBERS_PROFILE,
  SET_UNSEEN_MESSAGE_COUNT,
} from "./action.types";


export const setUnseenMessageCount = (count) => {
  return {
    type: SET_UNSEEN_MESSAGE_COUNT,
    payload: count,
  };
};

export const resetUnseenMessageCount = () => ({
  type: RESET_UNSEEN_MESSAGE_COUNT,
});

export const setJobMembersProfile = (data) => ({
  type: SET_JOB_MEMBERS_PROFILE,
  payload: data,
});

export const setChatReceiverDetails = (data) => ({
  type: SET_CHAT_RECEIVER_DETAILS,
  payload: data,
});

export const fetchJobMessagesProfile = () => {
  return async (dispatch) => {
    try {
      const { data, success } = await jobMembersProfile();

      if (success) {
        //Sorting appliedJobs inside each profile
        const profilesWithSortedJobs = data.map((profile) => {
          const sortedAppliedJobs = [...profile.appliedJobs].sort((a, b) => {
            const aTime = a.lastMessageCreatedAt
              ? dayjs(a.lastMessageCreatedAt)
              : null;
            const bTime = b.lastMessageCreatedAt
              ? dayjs(b.lastMessageCreatedAt)
              : null;

            if (aTime && bTime) return bTime.diff(aTime);
            if (aTime) return -1;
            if (bTime) return 1;
            return 0;
          });

          return {
            ...profile,
            appliedJobs: sortedAppliedJobs,
          };
        });

        //Sorting outer profiles by latest message across their appliedJobs
        const sortedProfiles = profilesWithSortedJobs.sort((a, b) => {
          const getLatestMessageTime = (jobs) =>
            jobs.reduce((latest, job) => {
              const msgTime = job.lastMessageCreatedAt
                ? dayjs(job.lastMessageCreatedAt)
                : null;
              return msgTime && (!latest || msgTime.isAfter(latest))
                ? msgTime
                : latest;
            }, null);

          const latestA = getLatestMessageTime(a.appliedJobs);
          const latestB = getLatestMessageTime(b.appliedJobs);

          if (latestA && latestB) return latestB.diff(latestA);
          if (latestA) return -1;
          if (latestB) return 1;
          return 0;
        });

        dispatch(setJobMembersProfile(sortedProfiles));
      }
    } catch (error) {
      console.error("Error fetching job message profile:", error);
    }
  };

  // return async (dispatch) => {
  //   try {
  //     const { data, success } = await jobMembersProfile();
  //     if (success) {
  //       const sortedProfiles = data.sort((a, b) => {
  //         const latestMessageA = a.appliedJobs.reduce((latest, job) => {
  //           return job.lastMessageCreatedAt &&
  //             (!latest ||
  //               dayjs(job.lastMessageCreatedAt).isAfter(dayjs(latest)))
  //             ? job.lastMessageCreatedAt
  //             : latest;
  //         }, null);

  //         const latestMessageB = b.appliedJobs.reduce((latest, job) => {
  //           return job.lastMessageCreatedAt &&
  //             (!latest ||
  //               dayjs(job.lastMessageCreatedAt).isAfter(dayjs(latest)))
  //             ? job.lastMessageCreatedAt
  //             : latest;
  //         }, null);

  //         if (latestMessageA && latestMessageB) {
  //           return dayjs(latestMessageB).diff(dayjs(latestMessageA));
  //         }

  //         if (latestMessageA) return -1;
  //         if (latestMessageB) return 1;

  //         return 0;
  //       });
  //       dispatch(setJobMembersProfile(sortedProfiles));
  //     }
  //   } catch (error) {
  //     console.error("Error fetching job message profile:", error);
  //   }
  // };
};

export const fetchUnseenMessageCount = () => {
  return async (dispatch) => {
    try {
      const { data, success } = await unseenMessageCount();

      if (success) {
        dispatch(setUnseenMessageCount(data));
      }
    } catch (error) {
      console.error("Error fetching unseen message count:", error);
    }
  };
};
